"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderInsetElementLeading = exports.isOptionGroupsAvailable = void 0;
exports.renderInsetElementTrailing = renderInsetElementTrailing;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _isHighContrast = require("../utils/isHighContrast");

var _form = require("../form");

var _icons = require("../icons");

var _layout = require("../layout");

var _constants = require("./constants");

var _core = require("@emotion/core");

var iconColor = _isHighContrast.isInHighContrast ? _constants.WHCM_SEARCH_ICON_COLOR : _constants.SEARCH_ICON_COLOR;

var VerticalDivider = function VerticalDivider(props) {
  return (0, _core.jsx)(_layout.Row, (0, _extends2.default)({
    backgroundColor: "neutral20",
    width: 2,
    margin: "4px 8px"
  }, props));
};

function renderInsetElementTrailing(_ref) {
  var clearButtonAltText = _ref.clearButtonAltText,
      clearButtonRef = _ref.clearButtonRef,
      disabled = _ref.disabled,
      handleClearButtonClick = _ref.handleClearButtonClick,
      hasSubmitButton = _ref.hasSubmitButton,
      onSubmitClick = _ref.onSubmitClick,
      query = _ref.query,
      submitButtonAltText = _ref.submitButtonAltText;
  var hasClearButton = !!query && !disabled;

  if (!hasSubmitButton && !hasClearButton) {
    return undefined;
  }

  var width = hasSubmitButton ? _constants.WITH_SUBMIT_BUTTON_TRAILING_WIDTH : _constants.WITHOUT_SUBMIT_BUTTON_TRAILING_WIDTH;
  var clearButtonComponent = (0, _core.jsx)(_form.InputClearButton, {
    altText: clearButtonAltText,
    iconColor: iconColor,
    innerRef: clearButtonRef,
    onClick: handleClearButtonClick
  });
  return {
    element: hasSubmitButton ? (0, _core.jsx)(_layout.Row, null, hasClearButton && (0, _core.jsx)(_react.default.Fragment, null, clearButtonComponent, (0, _core.jsx)(VerticalDivider, null)), (0, _core.jsx)(_form.InputActionButton, {
      iconColor: !hasClearButton ? _constants.SEARCH_ICON_COLOR_DISABLED : iconColor,
      icon: _icons.IconSearch,
      altText: submitButtonAltText,
      onClick: function onClick() {
        return onSubmitClick && onSubmitClick();
      },
      type: "submit",
      disabled: !hasClearButton
    })) : clearButtonComponent,
    inset: _constants.INSET_ELEMENT_TRAILING_INSET,
    width: width
  };
}

var renderInsetElementLeading = function renderInsetElementLeading(_ref2) {
  var disabled = _ref2.disabled,
      hasSubmitButton = _ref2.hasSubmitButton;

  if (disabled || hasSubmitButton) {
    return undefined;
  }

  return {
    element: (0, _core.jsx)(_icons.IconSearch, {
      size: _icons.IconSize.Small,
      "aria-hidden": true,
      color: iconColor
    })
  };
};

exports.renderInsetElementLeading = renderInsetElementLeading;

var isOptionGroupsAvailable = function isOptionGroupsAvailable(results) {
  return results && results.length > 0 && results[0].hasOwnProperty('groupName') && results[0].hasOwnProperty('values');
};

exports.isOptionGroupsAvailable = isOptionGroupsAvailable;